<script>
import Papa from 'papaparse';
import axios from 'axios';
import { onMount, onDestroy } from 'svelte';

let results = [];
let organizedResults = [];
let undeclared = 100;
let dynamicLink = '#'; // Initialize dynamicLink with a default value

const partyColors = {
  Conservative: '#18a1cd', // Blue
  Labour: '#c71e1d',       // Red
  SNP: '#FFF95D',          // Yellow
  'Lib Dem': '#FAA61A',    // Orange
  Green: '#6AB023',        // Green
  Reform: '#A2DBE1',       // Purple
  Other: '#000000'         // Grey
};

let leaders = [
  { name: "Keir Starmer", party: "Labour", image: "Keir.jpg", seats: 0, change: 0 },
  { name: "Rishi Sunak", party: "Conservative", image: "Rishi2.jpg", seats: 0, change: 0 },
  { name: "Ed Davey", party: "Lib Dem", image: "davey.jpeg", seats: 0, change: 0 },
  { name: "Stephen Flynn", party: "SNP", image: "Swinney2.jpg", seats: 0, change: 0 },
  { name: "Sian Bailey", party: "Green", image: "", seats: 0, change: 0 },
  { name: "Nigel Farage", party: "Reform", image: "Farage.jpg", seats: 0, change: 0 }, // Updated image for Reform Leader
  { name: "", party: "Other", image: "", seats: 0, change: 0 }
];

const nonStackedParties = ["Labour", "Conservative", "Lib Dem", "SNP", "Reform"]; // Moved Reform here
const stackedPartiesDesktop = ["Green", "Other"];
const allPartiesMobile = ["Lib Dem", "SNP", "Green", "Reform", "Other"];

async function fetchCSV() {
  const url = 'https://spec-election-data.s3.amazonaws.com/election-data.csv';

  try {
    const response = await axios.get(url);
    const data = Papa.parse(response.data, { header: true }).data;

    // Process the data and populate the results array
    const initialSeats = {};
    const seatChanges = {};
    data.forEach(row => {
      initialSeats[row.party] = parseInt(row.seats);
      seatChanges[row.party] = parseInt(row.Change); // Assuming change is the column name
    });

    results = generateResults(initialSeats, seatChanges);
    handleResize(); // Adjust column count based on viewport size
    undeclared = initialSeats.Undeclared || 0; // Update undeclared seats if present
    updateLeaderStats();
  } catch (error) {
    console.error('Error fetching CSV data:', error);
  }
}

function generateResults(initialSeats, seatChanges) {
  let results = [];
  const sortedParties = sortPartiesBySeats(initialSeats); // Ensure this sorts from highest to lowest seat count
  sortedParties.forEach(([party, count]) => {
    for (let i = 0; i < count; i++) {
      results.push({
        seat: `${party} Seat ${i + 1}`,
        party: party,
        change: seatChanges[party] || 0 // Read change in seats directly from the CSV
      });
    }
  });
  return results;
}

function checkEmbedType() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('embed') === 'app') {
    document.body.classList.add('app-embed');
    console.log('app-embed')
  }
  if (urlParams.get('link')) {
    dynamicLink = urlParams.get('link');
  }
  console.log(urlParams.get('embed'))
}

function getShortenedPartyName(party) {
  const shortenedNames = {
    Labour: 'Lab',
    Conservative: 'Con',
    'Lib Dem': 'Lib',
    SNP: 'SNP',
    Green: 'Grn',
    Reform: 'Ref',
    Other: 'Oth'
  };
  return shortenedNames[party] || party;
}

function sortPartiesBySeats(initialSeats) {
  const entries = Object.entries(initialSeats);
  return entries.sort((a, b) => {
    // Handle the "Labour" party to always place it first
    if (a[0] === "Labour") return -1;
    if (b[0] === "Labour") return 1;

    // Handle the "Other" party to always place it last
    if (a[0] === "Other") return 1;
    if (b[0] === "Other") return -1;

    // Normal descending sort by seat count
    return b[1] - a[1];
  });
}

function organizeColumns(results, totalColumns = 130) {
  let totalSeats = results.length;
  let minRowsPerColumn = Math.floor(totalSeats / totalColumns);
  let extraSeats = totalSeats % totalColumns;
  let columns = Array.from({ length: totalColumns }, () => []);
  let columnIndex = 0;

  results.forEach((result, index) => {
    if (columns[columnIndex].length === minRowsPerColumn + (extraSeats > 0 ? 1 : 0)) {
      if (extraSeats > 0) extraSeats--;
      columnIndex++; // Increment to next column only when the current one is fully populated
    }
    if (columnIndex < columns.length) { // Check to avoid going out of the column range
      columns[columnIndex].push(result);
    }
  });

  // Ensure columns are filled from the bottom
  columns = columns.map(column => {
    column.reverse();
    return column;
  });

  // Flatten the columns into a single array for rendering, ensuring no gaps
  let organizedResults = [];
  for (let row = 0; row <= minRowsPerColumn; row++) {
    for (let col = 0; col < totalColumns; col++) {
      if (columns[col][row]) {
        organizedResults.push(columns[col][row]);
      }
    }
  }

  return organizedResults;
}

function updateLeaderStats() {
  leaders = leaders.map(leader => {
    const seatsWon = results.filter(r => r.party === leader.party).length;
    const seatChange = results.reduce((total, current) => (current.party === leader.party ? total + current.change : total), 0);
    return { ...leader, seats: seatsWon, change: seatChange };
  });
}

function generateInitialSeats(count) {
  return Array(count).fill({ seat: "Unassigned", party: "Other", change: 0 });
}

function handleResize() {
  let totalColumns = window.innerWidth < 821 ? 65 : 130;
  organizedResults = organizeColumns(results, totalColumns);
}

$: fetchCSV(); // Fetch data when component mounts

onMount(() => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('link')) {
    dynamicLink = urlParams.get('link');
  }
  window.addEventListener('resize', handleResize);
  handleResize(); // Initial call to set up the correct columns
  function sendPageHeight() {
    var message = {
        "event": "BoltIframeHeight",
        "iframe": window.name,
        "iframeSrc": window.location.href,
        "height": document.querySelector('.anchor_link').clientHeight + 70 
    };
    parent.postMessage(message, '*');
    console.log(message);
  }
  sendPageHeight();
  checkEmbedType();
  return () => {
    window.removeEventListener('resize', handleResize);
  };
});

// window.dataLayer.push({event: " click", action: "OJU_click_election - banner"});

setInterval(fetchCSV, 60000); // Fetch data every 60 seconds
</script>

<style>
@font-face {
  font-family: 'goudy-old-style';
  src: url('/fonts/goudy.ttf') format('truetype');
}

.container {
  display: grid;
  grid-template-columns: 1fr; /* One full-width column */
  grid-template-rows: auto 1fr auto; /* Auto height for leaders, remaining space for seats, and additional results */
  width: 100%;
  overflow-x: hidden; /* Prevent horizontal overflow */
  max-width: 1500px;
  margin: auto;
}

.leader-profiles {
  display: flex; /* Use flexbox for horizontal layout */
  flex-direction: row; /* Align items in a row */
  justify-content: start; /* Align items to the start of the flex container */
  gap: 20px; /* Space between each leader profile */
  padding: 10px;
  color: rgba(38,34,34,.6);
  margin: auto;
  font-family: goudy-old-style, sans-serif;
  overflow-x: hidden; /* Prevent horizontal overflow */
}

.other-results {
  display: none; /* Hide other results by default */
  flex-direction: row; /* Horizontal layout for mobile */
  gap: 10px; /* Space between each party result */
  padding: 10px;
  font-family: goudy-old-style, sans-serif;
  color: rgba(38,34,34,.6);
  flex-wrap: wrap; /* Allow wrapping to a new row */
}

.seats-container {
  display: grid;
  grid-template-columns: repeat(130, 1fr);
  gap: 1px;
  background: #f4f4f4;
  width: 100%;
  position: relative;
  overflow-x: hidden; /* Prevent horizontal overflow */
  overflow-y: hidden; /* Prevent vertical overflow */
}

.seat {
  width: 100%;
  padding-top: 100%;
  position: relative;
}

.seat::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--seatColor, #ccc);
}

.majority-point::before {
  content: '';
  position: absolute;
  left: 50%; /* Centers the line at the 326th seat */
  top: 0; /* Starts right at the top edge of the grid */
  height: 100%; /* Covers the full height of the grid */
  width: 2px; /* Line thickness */
  background-color: #1a1a1a; /* Highly visible red line */
  transform: translateX(-50%) translateY(-2px); /* Perfectly centers the line and extends slightly above */
}

.majority-point::after {
  content: '';
  position: absolute;
  left: 50%; /* Centers the line at the 326th seat */
  bottom: 0; /* Starts right at the bottom edge of the grid */
  height: 100%; /* Covers the full height of the grid */
  width: 2px; /* Line thickness */
  background-color: #1a1a1a; /* Highly visible red line */
  transform: translateX(-50%) translateY(2px); /* Perfectly centers the line and extends slightly below */
}

.leader-profile {
  display: flex;
  align-items: center;
  text-align: left;
  gap: 15px;
}

.leader-profiles > .leader-profile {
  display: none; /* Hide all leader profiles by default on mobile */
}

.leader-profiles > .labour, .leader-profiles > .conservative {
  display: flex; /* Show only Labour and Conservative leader profiles on mobile */
}

@media (min-width: 1060px) {
  .leader-profiles > .leader-profile {
    display: flex; /* Show all leader profiles on larger screens */
  }

  .other-results {
    display: none; /* Hide other results on larger screens */
  }
}

.leader-image {
  width: 75px;
  height: 75px;
  background-size: cover;
  background-position: right;
  margin-right: 0; /* Remove negative margin */
}

.party-name {
  display: flex;
  align-items: center;
  font-weight: bold;
}

.party-color {
  width: 15px;
  height: 15px;
  margin-right: 10px;
  background-color: var(--partyColor);
}

.stacked-leaders {
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center vertically */
  gap: 5px; /* Reduce gap between stacked items */
}

.stacked-leaders .leader-profile {
  font-size: 0.9em; /* Increase font size for stacked leaders */
  gap: 5px; /* Reduce gap inside stacked leader profile */
}

.stacked-leaders .party-name {
  margin-right: 10px; /* Add some space between the name and the seat results */
}

.full-name {
  display: inline; /* Show full name by default */
}

.short-name {
  display: none; /* Hide short name by default */
}


@media (max-width: 1060px) {
 .full-name {
    display: none; /* Hide full name on mobile */
  }

  .short-name {
    display: inline; /* Show short name on mobile */
  }
  
  .container {
    display: block;
    overflow-x: hidden; /* Prevent horizontal overflow */
  }
  .leader-profiles {
    flex-direction: row;
    justify-content: center;
    margin: unset;
    overflow-x: hidden; /* Prevent horizontal overflow */
    font-size: 0.8em;
  }

  .other-results {
    display: flex; /* Show other results on mobile */
    overflow-x: hidden; /* Prevent horizontal overflow */
    flex-wrap: wrap; /* Allow wrapping to a new row */
    font-size: 0.8em; /* Reduce font size */
    justify-content: space-between;
    padding: 5px 10px 5px 10px;
  }

  .seats-container {
     grid-template-columns: repeat(65, 1fr); 
     overflow-x: hidden; /* Prevent horizontal overflow */
     overflow-y: hidden; /* Prevent vertical overflow */
     max-height: 75px;
  }

   .labour .leader-image {
    margin-right: -20px; /* Adjust specific margin for Keir Starmer */
  }


  .stacked-leaders {
    display: none; /* Hide stacked leaders on mobile */
  }
  

}
a{
text-decoration: none;
color: inherit;
}
@media (prefers-color-scheme: dark) {


  .majority-point::before, .majority-point::after {
    background-color: #ff5555; /* Bright majority line */
  }

  .party-color {
    border: 1px solid #ddd; /* Visible borders in dark mode */
  }



  a {
    color: #4da6ff; /* Link colors for dark mode */
  }
  
  /* Styles for app embedding */
:global(body.app-embed) {
  color: #fff; /* Example: Different text color for app embed */
}

:global(body.app-embed) .leader-profiles {
  color: #fff;
}

:global(body.app-embed) .other-results {
  color: #fff;
}
}

</style>
<div class="anchor_link">
<a href={dynamicLink} target="_parent" class="anchor_link">
<div class="container">
  <div class="leader-profiles">
    {#each leaders.filter(leader => nonStackedParties.includes(leader.party)) as leader}
      <div class="leader-profile {leader.party.toLowerCase().replace(' ', '-')}">
        {#if leader.image}
          <div class="leader-image" style="background-image: url({leader.image});"></div>
        {/if}
        <div>
          <div class="party-name">
            <div class="party-color" style="--partyColor: {partyColors[leader.party]}"></div>
            <span class="full-name">{leader.party}</span>
            <span class="short-name">{getShortenedPartyName(leader.party)}</span>
          </div>
          <p><big>{leader.seats}</big></p>
        </div>
      </div>
    {/each}
    <div class="stacked-leaders">
      {#each leaders.filter(leader => stackedPartiesDesktop.includes(leader.party)) as leader}
        <div class="leader-profile {leader.party.toLowerCase().replace(' ', '-')}">
          <div>
            <div class="party-name">
              <div class="party-color" style="--partyColor: {partyColors[leader.party]}"></div>
              <span class="full-name">{leader.party}</span>
              <span class="short-name">{getShortenedPartyName(leader.party)}</span>
              <span>&nbsp; {leader.seats}</span>
            </div>
          </div>
        </div>
      {/each}
    </div>
  </div>
  <div class="seats-container">
    {#each organizedResults as result, index}
      <div class="seat" style="--seatColor: {partyColors[result.party]}"></div>
    {/each}
    <div class="majority-point"></div> <!-- This is the line element -->
  </div>
  <div class="other-results">
    {#each leaders.filter(leader => allPartiesMobile.includes(leader.party)) as leader}
      <div class="leader-profile {leader.party.toLowerCase().replace(' ', '-')}">
        <div class="party-name">
          <div class="party-color" style="--partyColor: {partyColors[leader.party]}"></div>
          <span class="full-name">{leader.party}</span>
          <span class="short-name">{getShortenedPartyName(leader.party)}</span>
          <span>&nbsp; {leader.seats}</span>
        </div>
      </div>
    {/each}
  </div>
  <b class="seatstogo"><small>{undeclared} seats yet to declare</small></b>
</div>
</a>
</div>